document.addEventListener('click', function (event) {
  const faqButton = event.target.closest('.faq-item button');
  if (faqButton) {
    const item = faqButton.closest('.faq-item');
    const accordion = item.closest('.accordion');
    const isOpen = item.classList.contains('is-open');

    if (accordion) {
      accordion.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const openButton = openItem.querySelector('button');
          const openBody = openItem.querySelector('.faq-item__body');
          if (openButton) openButton.setAttribute('aria-expanded', 'false');
          if (openBody) openBody.style.display = 'none';
        }
      });
    }

    item.classList.toggle('is-open', !isOpen);
    faqButton.setAttribute('aria-expanded', String(!isOpen));
    const body = item.querySelector('.faq-item__body');
    if (body) body.style.display = isOpen ? 'none' : 'block';
    return;
  }

  const mobileToggle = event.target.closest('[data-mobile-toggle]');
  if (mobileToggle) {
    document.body.classList.toggle('menu-open');
  }

  const stickyButton = event.target.closest('[data-submit-main-product]');
  if (stickyButton) {
    const productForm = document.querySelector('.product-form-conversion');
    if (!productForm) return;
    const submitButton = productForm.querySelector('button[type="submit"]');
    if (submitButton) submitButton.click();
  }
});

function updateCartCountDisplay(delta) {
  const cartLink = document.querySelector('.nav__actions a[href="/cart"]') || document.querySelector('.nav__actions a[href="/cart/"]');
  if (!cartLink) return;
  const match = cartLink.textContent.match(/\((\d+)\)/);
  const current = match ? parseInt(match[1], 10) : 0;
  const next = Math.max(0, current + delta);
  cartLink.textContent = next > 0 ? `Cart (${next})` : 'Cart';
}

async function ajaxAddToCart(form) {
  const formData = new FormData(form);
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: formData
  });

  let payload = null;
  try {
    payload = await response.clone().json();
  } catch (e) {}

  if (!response.ok) {
    const message = payload && (payload.description || payload.message) ? (payload.description || payload.message) : 'Could not add this item to cart.';
    throw new Error(message);
  }

  updateCartCountDisplay(Number(formData.get('quantity') || 1));
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: payload || {} }));
  return payload;
}

document.addEventListener('submit', async function (event) {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;
  event.preventDefault();

  const submitButton = form.querySelector('button[type="submit"]');
  const originalText = submitButton ? submitButton.textContent : '';
  const statusTarget = form.querySelector('.product-form__status');

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';
  }
  if (statusTarget) statusTarget.textContent = '';

  try {
    await ajaxAddToCart(form);
    if (statusTarget) statusTarget.textContent = 'Added to cart.';
  } catch (error) {
    if (statusTarget) {
      statusTarget.textContent = error.message || 'Could not add this item to cart.';
    } else {
      alert(error.message || 'Could not add this item to cart.');
    }
  } finally {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  }
}, true); // capture phase: preventDefault runs before Shopify's form listener → one AddToCart per click

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.body.classList.remove('menu-open');
  }
});
